import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
import {ApolloProvider} from "react-apollo";
import {BrowserRouter} from "react-router-dom";
import Application from "./metamodel/Application";
import ScrollToTop from "./utils/ScrollToTop";
import {createClient} from "./client";
import {FieldType} from "./metamodel/IField";
import LengthIntervalField from "./metamodel/Fields/LengthIntervalField";



// @ts-ignore
export const metaModel: Application = Application.deserialize(window.metaModel);
// @ts-ignore
export const headerUrl: string = window.headerUrl;
// @ts-ignore
export const logoUrl: string = window.logoUrl;
// @ts-ignore
export const aboutInfo: string = window.aboutInfo;
// @ts-ignore
export const hideGegevensBlock: boolean = window.hideGegevensBlock;
// @ts-ignore
export const switcherBackgroundUrl: string = window.switcherBackgroundUrl;

const defaults = metaModel.entities.reduce((res,e) => {
    res[e.id] = e.fields.filter(f => f.searchable).reduce(
        (result: any, value) => {
            if (value.type === FieldType.LengthInterval) {
                const lengthField = value as LengthIntervalField;
                result[value.id] = {
                    min: null,
                    minRaw: null,
                    minUnit: lengthField.minLengthUnit,
                    max: null,
                    maxRaw: null,
                    maxUnit: lengthField.maxLengthUnit,
                    __typename: `${value.id}Interval`
                };
            } else {
                result[value.id] = null;
            }
            result.__typename = `${e.id}Filter`;
            return result;
        },
        {}
    );
    return res;
}, {});


setTimeout(async () => {
    const client = await createClient(defaults);
    const ele = document.getElementById('ipl-progress-indicator');
    if(ele) {
        // fade out
        ele.classList.add('available');
        setTimeout(() => {
            // remove from DOM
            ele.outerHTML = ''
        }, 2000)
    }
    ReactDOM.render(
        <ApolloProvider client={client}>
            <BrowserRouter>
                <ScrollToTop>
                    <App aboutInfo={aboutInfo} logoUrl={logoUrl} headerUrl={headerUrl} metaModel={metaModel} hideGegevensBlock={hideGegevensBlock} switcherBackgroundUrl={switcherBackgroundUrl}/>
                </ScrollToTop>
            </BrowserRouter>
        </ApolloProvider>,
        document.getElementById('root') as HTMLElement
    );
 }, 400);



// WEBPACK FOOTER //
// ./src/index.tsx